import {EventRules} from '@/types'
import {contains, values, map} from 'ramda'

export const translationSupportedLanguages = [
  {code: 'DA', language: 'Dansk', flagCode: 'DK'},
  {code: 'DE', language: 'Deutsch', flagCode: 'DE'},
  {code: 'GB', language: 'English', flagCode: 'EN'},
  {code: 'FR', language: 'Français', flagCode: 'FR'},
  {code: 'IT', language: 'Italiano', flagCode: 'IT'},
  {code: 'NL', language: 'Nederlands', flagCode: 'NL'},
  {code: 'BE', language: 'Nederlands', flagCode: 'BE'},
  {code: 'NO', language: 'Norsk, Bokmål', flagCode: 'NO'},
  {code: 'JA', language: '日本語', flagCode: 'JP'},
  {code: 'SE', language: 'Swedish', flagCode: 'SE'},
]

export const isAnyTabDataLoaded = (flags) => contains(true, values(flags))
export const isHavingPortfolioId = ({activePortfolioId}) => activePortfolioId !== undefined && String(activePortfolioId)

export const getRuleName = (ruleName, l) => {
  if (ruleName) {
    let translatedRuleName = ruleName.trim()
    const braceIndex = translatedRuleName.indexOf('{')
    if (braceIndex > -1) {
      translatedRuleName = translatedRuleName.substr(0, braceIndex)
    }
    return splitBySymbolsAndTranslate(l, translatedRuleName.trim())
  }
  return ruleName
}
export const checkRuleText = (notificationEvent) => notificationEvent.ruleText ? notificationEvent.ruleText : notificationEvent.ruleName

const splitBySymbolsAndTranslate = (l, ruleName) => {
  ruleName = ruleName.split(' - ')
  const isHyphenExists = ruleName.length > 1
  ruleName = map((r) => {
    const index = r.indexOf(' |')
    if (index > -1) {
      r = r.substr(0, index)
    }
    return l(r.trim())
  }, ruleName)
  return isHyphenExists ? ruleName.join(' - ') : ruleName
}

export const getReportLinkDetailsForGA = (userCountryCode: string, companyId: string) => {
  const companyCountryCode = companyId.substr(0, 2)
  userCountryCode = userCountryCode === 'GB' ? 'UK' : userCountryCode
  return `${userCountryCode}-${companyCountryCode}-${companyId}-${(userCountryCode === companyCountryCode) ? 'domestic' : 'international'}`
}

export const supportedCountryCodesForImport = ['AF', 'AT', 'AU', 'BA', 'BE', 'BG', 'CA', 'CH', 'CN', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HK', 'HR', 'HU', 'IE',
  'IT', 'JP', 'KH', 'KR', 'LA', 'LI', 'LU', 'LV', 'MD', 'ME', 'MK', 'MM', 'MY', 'NL', 'NO', 'PL', 'PT', 'RO', 'RS', 'SE', 'SI', 'SK', 'TH', 'UA', 'US', 'VN', 'WW', 'XK']

export const countryListForSafeNumbersOnly = ['AF', 'DE', 'KH', 'LA', 'MM', 'MY', 'TH', 'VN', 'WW']

export const countryListForConnectIdOnly = ['BA', 'BG', 'CN', 'CZ', 'EE', 'GR', 'HK', 'HR', 'HU', 'LV', 'MD', 'ME', 'MK', 'PL', 'PT', 'RO', 'RS', 'SI', 'SK', 'UA', 'XK']

export const supportedNumberType = ['Safe Number', 'Org Number']

export const supportedNumberTypeCoface = ['Connect Id', 'Org Number']

export const isPermissionEnabled = (permissions: string = '', type = '') =>
  permissions && permissions.indexOf(type) > -1

/* export const isOnlyViewEnabled = (permissions: string = '') =>
  permissions && permissions.indexOf('View') > -1 && permissions.trim().slice(4) === '' */

export const isSharedPortfolio = (portfolio: Object = {}) => !!portfolio.sharedByUserName
export const handleGlobalAll = (rules: Array<EventRules>, check?: number,
  country?: string, e?: any, changeEventRule?: any) => {
  let inactiveRulesPresent = false
  let count = 0
  map((rule) => {
    map((r) => {
      if (r.isActive === 0 && rule.groupInfo.anyRuleCode !== r.ruleCode) inactiveRulesPresent = true
      if (e) {
        let eventRuleChange = {
          ruleCode: r.ruleCode,
          prop: 'isActive',
          val: (rule.groupInfo.anyRuleCode === r.ruleCode) ? 0 : check,
          check: false,
          count: 0,
        }
        changeEventRule(country, rule.groupInfo.groupId, eventRuleChange)
      }
    }, rule.notificationRules)
    if (rule.subGroupRules.length > 0) {
      map((subRule) => {
        map((r) => {
          if (r.isActive === 0) {
            inactiveRulesPresent = true
            count++
          }
          if (e) {
            let eventRuleChange = {
              ruleCode: r.ruleCode,
              prop: 'isActive',
              val: check,
              check: true,
              subGroupAllRules: rule.subGroupRules,
              subGroupName: subRule.name,
              count: count,
            }
            changeEventRule(country, rule.groupInfo.groupId, eventRuleChange)
          }
        }, subRule.subGroupRules)
      }, rule.subGroupRules)
    }
  }, rules)
  return inactiveRulesPresent
}
export const getElementIdName = (element) => {
  const idParts = element.split(' ')
  let idName = ''
  idParts.map((namePart, index) => {
    let id = ((index < 1) ? namePart.substr(0, 1).toLowerCase() : namePart.substr(0, 1).toUpperCase()) + namePart.substr(1)
    idName += id
    return idName
  })
  return idName
}

export const getColumnsWidth = (notAllPortfolio) => (columnName) => {
  return notAllPortfolio ? normalColumnWidths[columnName] : allPortfolioColumnWidths[columnName]
}

export const normalColumnWidths = {
  all: '6%',
  companyName: '14%',
  companyId: '10%',
  localOrgNumber: '12%',
  portfolioName: '10%',
  countryCode: '8%',
  personalReference: '10%',
  personalLimit: '10%',
  freeText: '10%',
  localScore: '10%',
  lastEventDate: '10%',
}

export const allPortfolioColumnWidths = {
  all: '2%',
  companyName: '14%',
  companyId: '10%',
  localOrgNumber: '10%',
  portfolioName: '10%',
  countryCode: '6%',
  personalReference: '8%',
  personalLimit: '10%',
  freeText: '8%',
  localScore: '8%',
  lastEventDate: '10%',
}

export const companiesColumnNames = [
  {key: 'companyName', name: 'Name'},
  {key: 'companyId', name: 'Safe number'},
  {key: 'localOrgNumber', name: 'Org Number'},
  {key: 'portfolioName', name: 'Portfolio'},
  {key: 'countryCode', name: 'Country'},
  {key: 'personalReference', name: 'Reference'},
  {key: 'personalLimit', name: 'Personal Limit'},
  {key: 'freeText', name: 'Notes'},
  {key: 'localScore', name: 'Score'},
  {key: 'lastEventDate', name: 'Last change'},
]



// WEBPACK FOOTER //
// ./src/views/util.js